import React, { useState } from 'react'
import { useAuth } from "../../../providers/AuthProvider";
import Form, { FormInputComponent } from "../../../components/form/Form";
import { Checkbox, InputNumber } from "antd";

const SupplierInfoStep = React.forwardRef(({ supplierOrg, isDisabled, onChange, isFormSubmitted,...props }, formRef) => {

    const { auth } = useAuth();

    const [editingIndex, setEditingIndex] = useState(false);

    let supplierFormClass = "talent-role-form";
    if (isDisabled) {
        supplierFormClass += ' pointer-events-none opacity-80';
    }
    return (
        <div>
            <div className="form-title-section">
                <div className="step-title-content">
                    <div>
                        <div className="flex items-center pb-4">
                            <h3 className="form-title !mb-0">
                                Agency Info
                            </h3>

                        </div>

                        <h5 className="form-subtitle">
                            Provide key information on your agency below.
                        </h5>
                    </div>
                </div>
            </div>

            <div className={supplierFormClass}>
                <Form
                    ref={formRef}
                    title={false}
                    subtitle={null}
                    showRequired
                    submitButton={false}
                    onChange={(model) => {
                        let updates = { ...model }
                        for (let [key, value] of Object.entries(model)) {
                            updates = TB.set(updates, key, value)
                        }
                        onChange(updates)
                    }}
                    model={supplierOrg}
                    fields={[]}
                    isDisabled={isDisabled}>

                    <div className="flex flex-col">
                        <div className="field-section flex-row">
                            <div className="field px-3.5 basis-8/12">
                                <FormInputComponent
                                    fieldName="name"
                                    value={supplierOrg.name}
                                    type={'text'}
                                    label="Agency Name"
                                    maxLength={255}
                                    required={true}
                                    placeholder="Name"
                                    style={styles.field}
                                />
                            </div>
                        </div>

                        <div className="field-section flex-row">

                            <div className="field px-3.5 basis-5/12">
                                <FormInputComponent
                                    fieldName="size"
                                    value={supplierOrg.size}
                                    label={TB.trans('clients.edit_company_profile.size_label')}
                                    type={'select'}
                                    required={true}
                                    options={laravel.client_sizes}
                                />
                            </div>
                            <div className="field px-3.5 basis-5/12">
                                <FormInputComponent
                                    fieldName="website"
                                    value={supplierOrg.website}
                                    label="Website"
                                    placeholder="URL"
                                    onBlur={e => {
                                        console.log('supplierOrg.website', supplierOrg.website)
                                        if (!supplierOrg?.approved_email_domains?.length) {
                                            try {
                                                let website = new URL(supplierOrg.website);
                                                onChange({approved_email_domains: [website.hostname]});
                                            } catch (error) {
                                                console.log('error', error)
                                            }
                                        }
                                    }}
                                    type="url"
                                    maxLength={255}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="flex flex-col items-start mt-3">
                            <div className="field-section flex-row">
                                <div className="field">
                                    <div className="field-element">
                                        <div style={{ flexBasis: '100%' }}>
                                            <h5 className="form-header">Location</h5>
                                            <p className="form-subheader">Where is your main office location? Add additional office locations if needed</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Ensure at least one location exists */}
                            <div className="field-section flex-row">
                                <div className="field px-3.5 basis-8/12">
                                    <FormInputComponent
                                        fieldName="location"
                                        value={supplierOrg.location}
                                        type="location"
                                        label="Main Office"
                                        required={true}
                                        placeholder="Search for your main office location..."
                                        style={styles.field}
                                        additionalProps={{ is_default: true }}
                                        showClearButton={!supplierOrg.locations?.length}
                                    />
                                </div>
                            </div>

                            {supplierOrg.locations?.length > 0 && (
                                <div className="w-full">
                                    <div className="field-section flex row">
                                        <div className="field px-3">
                                            <label className="col-form-label">
                                                Additional Office Locations
                                            </label>
                                        </div>
                                    </div>


                                    {TB.map(supplierOrg.locations, (location, lIndex) => (
                                        <div className="field-section flex-row"
                                            key={`location-${lIndex}`}>
                                            <div className="field px-3.5 basis-8/12 email-domain">
                                                <FormInputComponent
                                                    fieldName={`locations[${lIndex}]`}
                                                    value={location || ''}
                                                    type="location"
                                                    label={false}
                                                    required={true}
                                                    placeholder={"Search for additional office location..."}
                                                    style={styles.field}
                                                    additionalProps={{ is_default: false }}
                                                    showClearButton={false}
                                                    addonAfter={(
                                                        <button
                                                            type="button"
                                                            disabled={isDisabled}
                                                            className="px-1.5"
                                                            onClick={async () => {
                                                                const locationsList = TB.xor([...(supplierOrg.locations || [])], [location]);
                                                                await onChange({ locations: locationsList })
                                                            }}
                                                        >
                                                            <i className="fas fa-times-circle text-gray" />
                                                        </button>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* {supplierOrg.locations?.length > 0 ? TB.map(supplierOrg.locations, (location, lIndex) => (
                                <div className="field-section flex-row"
                                    key={`location-${lIndex}`}>
                                    <div className="field px-3.5 basis-8/12 email-domain">
                                        <FormInputComponent
                                            fieldName={`locations[${lIndex}]`}
                                            value={location || ''}
                                            type="location"
                                            label={false}
                                            required={true}
                                            placeholder={"Search for additional office location..."}
                                            style={styles.field}
                                            additionalProps={{ is_default: false }}
                                            showClearButton={true}
                                            showRemoveButton={true}
                                            onRemoveLocation={() => {
                                                onChange({
                                                    locations: TB.filter(...(supplierOrg.locations || []), (location, fIndex) => {
                                                        return fIndex !== lIndex;
                                                    })
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            )) : null} */}

                            <div className="field-section flex-row">
                                <div className="field px-3.5">
                                    <button
                                        type="button"
                                        className="btn btn-outline-dark mt-3 flex flex-row gap-2 items-center"
                                        // disabled add button if a location is invalid
                                        disabled={isDisabled || (supplierOrg.locations?.length > 0 && TB.filter(supplierOrg.locations || [], loc => !loc?.latitude)?.length > 0) || !TB.isDefined(supplierOrg.location?.latitude)}
                                        onClick={async () => {
                                            let locations = [...(supplierOrg.locations || [])];
                                            if (locations.length === 0) {
                                                // If no locations exist, initialize with empty main location
                                                locations.push({});
                                            } else {
                                                locations.push({});
                                            }
                                            await onChange({ locations: locations })
                                        }}>
                                        <i className="fas fa-plus" /> Add Office Location
                                    </button>

                                </div>
                            </div>
                        </div>

                        <hr />


                        <div className="flex flex-col items-start">
                            <div className="field-section flex row">
                                <div className="field px-3 5">
                                    <label className="col-form-label">
                                        Email Domain(s) Used
                                        <span className="required-symbol"> *</span>
                                    </label>
                                </div>
                            </div>

                            {supplierOrg.approved_email_domains?.length > 0 ? TB.map(supplierOrg.approved_email_domains, (domain, dIndex) => (
                                <div className="field-section flex-row"
                                    key={`domain-${dIndex}`}>
                                    <div className="field px-3.5 basis-5/12 email-domain">
                                        <FormInputComponent
                                            fieldName={`approved_email_domains[${dIndex}]`}
                                            value={domain || ''}
                                            type="text"
                                            validation={{
                                                rules: {
                                                    matchRegexp: /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/,
                                                },
                                                errors: {
                                                    matchRegexp: 'Invalid domain name',
                                                }
                                            }}
                                            validateBeforeSubmit={true}
                                            required={true}
                                            showRequired={true}
                                            label={false}
                                            placeholder="example.com"
                                            addonBefore="@"
                                            addonAfter={supplierOrg.approved_email_domains?.length > 1 && (
                                                <button type="button" disabled={isDisabled} onClick={async () => {
                                                    let approved_emails = TB.xor([...(supplierOrg.approved_email_domains || [])], [domain]);

                                                    await onChange({ approved_email_domains: approved_emails })
                                                }}>
                                                    <i className="fas fa-times-circle text-gray" />
                                                </button>
                                            )}
                                            maxLength={200}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                            )) : (
                                <div className="hidden-email-check px-3.5">
                                    <FormInputComponent
                                        fieldName="approved_email_domain_check"
                                        value={''}
                                        label={false}
                                        type={'text'}
                                        required={true}
                                        validationErrors={{
                                            isDefaultRequiredValue: 'You must have a least one approved email domain in order to invite talent resources.',
                                        }}
                                    />
                                </div>
                            )}

                            <div className="field-section flex row">
                                <div className="field px-3.5">
                                    <button type="button" disabled={isDisabled} className="btn btn-outline-dark mt-3"
                                        onClick={async () => {
                                            let approved_emails = [...(supplierOrg.approved_email_domains || [])];

                                            approved_emails.push('');
                                            await onChange({ approved_email_domains: approved_emails })
                                        }}>
                                        Add Email Domain
                                    </button>
                                </div>
                            </div>

                        </div>

                        <hr />

                        <div className="field-section flex-row">
                            <div className="field px-3.5 basis-4/12">
                                <FormInputComponent
                                    fieldName="logo_path"
                                    value={supplierOrg.logo_path}
                                    label={"Agency Logo"}
                                    type="pixie"
                                    ratio={"1:1"}
                                    circular={false}
                                    required={false}
                                    style={styles.field}
                                />
                            </div>
                            <div className="field px-3.5 basis-8/12">
                                <FormInputComponent
                                    fieldName="banner_image_path"
                                    value={supplierOrg.banner_image_path}
                                    label="Banner Image"
                                    labelHint="Note: Image will be cropped to 16x9 aspect for display purposes"
                                    type="pixie"
                                    ratio="16:9"
                                    circular={false}
                                    width={400}
                                    shouldResize={true}
                                    validationErrors={{
                                        isDefaultRequiredValue: 'A cover image for your portfolio is required',
                                    }}
                                    required={false}
                                    style={styles.field}
                                />
                            </div>
                        </div>
                        <div className="field-section flex-row">
                            <div className="field px-3.5 basis-10/12">
                                <FormInputComponent
                                    fieldName="about"
                                    value={supplierOrg.about}
                                    label="Agency Background Info"
                                    placeholder={"Write a short description about your agency's background and/or history."}
                                    type={'editor'}
                                    disableAutoFocus={true}
                                    required={true}
                                    style={styles.field}
                                    maxLength={10000}
                                    minLength={50}
                                    enableScroll={true}
                                    validation={{
                                        rules: { maxLength: 10000 },
                                        errors: {
                                            maxLength: TB.trans('validation.max.string', {
                                                'attribute': 'about',
                                                'max': 10000
                                            }),
                                            minCharLength: TB.trans('validation.min.string', {
                                                'attribute': 'about',
                                                'min': 50
                                            })
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <hr />
                        <div className="field-section flex-row">
                            <div className="field">
                                <div className="form-title-section">
                                    <div className="step-title-content">
                                        <div>
                                            <h3 className="form-title">
                                                Preferences
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="field-section flex-row">
                            <div className="field px-3.5 basis-10/12">
                                <FormInputComponent
                                    fieldName="offers_service_work"
                                    value={supplierOrg.offers_service_work}
                                    label="Is your agency interested in project-based work assignments?"
                                    type={'switch'}
                                    onLabel={'Yes'}
                                    offLabel={'No'}
                                    required={false}
                                    style={{ borderBottom: '1px solid #E5E5E5', paddingBottom: 8 }}
                                    switchStyle={{
                                        onColor: TB.config('color.light_green'), // green
                                        offColor: '#90A0B7', // dark gray
                                        textColor: '#000000', // black
                                    }}
                                />
                            </div>
                        </div>
                        <div className="field-section flex-row">
                            <div className="field px-3.5 basis-10/12">
                                <FormInputComponent
                                    fieldName="offers_byo_work"
                                    value={supplierOrg.offers_byo_work}
                                    label="Is your agency interested in providing individual resources for staff augmentation?"
                                    type={'switch'}
                                    onLabel={'Yes'}
                                    offLabel={'No'}
                                    required={false}
                                    style={{ borderBottom: '1px solid #E5E5E5', paddingBottom: 8 }}
                                    switchStyle={{
                                        onColor: TB.config('color.light_green'), // green
                                        offColor: '#90A0B7', // dark gray
                                        textColor: '#000000', // black
                                    }}
                                />
                            </div>
                        </div>

                        <hr />
                        <div className="field-section flex-row">
                            <div className="field">
                                <div className="form-title-section">
                                    <div className="step-title-content">
                                        <div>
                                            <h3 className="form-title">
                                                Diversity Information
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="field-section flex-row">
                            <div className="field px-3.5 basis-6/12">
                                <FormInputComponent
                                    fieldName="is_woman_owned"
                                    value={supplierOrg.is_woman_owned}
                                    type='antd-input'
                                    className="mb-0"
                                    label={false}
                                    required={false}
                                >
                                    <Checkbox
                                        disabled={isDisabled}
                                        checked={supplierOrg.is_woman_owned}>
                                        <span className="text-sm">
                                            Woman-owned business
                                        </span>
                                    </Checkbox>
                                </FormInputComponent>
                            </div>
                            <div className="field px-3.5 basis-6/12">
                                <FormInputComponent
                                    fieldName="is_black_owned"
                                    value={supplierOrg.is_black_owned}
                                    type='antd-input'
                                    className="mb-0"
                                    label={false}
                                    required={false}
                                >
                                    <Checkbox
                                        disabled={isDisabled}
                                        checked={supplierOrg.is_black_owned}>
                                        <span className="text-sm">
                                            Black-owned business
                                        </span>
                                    </Checkbox>
                                </FormInputComponent>
                            </div>
                        </div>

                        <hr />
                        <div className="field-section flex-row">
                            <div className="field">
                                <div className="form-title-section">
                                    <div className="step-title-content">
                                        <div>
                                            <h3 className="form-title">
                                                Client Size Target
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="field-section flex-row">
                            <div className="field px-3.5">
                                <div className="form-group flex flex-col items-stretch">
                                    <label className="col-form-label">
                                        What client sizes does your agency target? (Select all that apply)
                                    </label>
                                    <div className="pl-3 form-group flex flex-row flex-wrap justify-start items-start max-w-[550px]">
                                        <div className="basis-1/2">
                                            <FormInputComponent
                                                value={supplierOrg.targets_clients_enterprise}
                                                fieldName="targets_clients_enterprise"
                                                type='antd-input'
                                                className="mb-0"
                                                label={false}
                                                required={false}
                                            >
                                                <Checkbox
                                                    disabled={isDisabled}
                                                    checked={supplierOrg.targets_clients_enterprise}>
                                                    <span className="text-sm">
                                                        Enterprise
                                                    </span>
                                                </Checkbox>
                                            </FormInputComponent>
                                        </div>
                                        <div className="basis-1/2">
                                            <FormInputComponent
                                                value={supplierOrg.targets_clients_mid}
                                                fieldName="targets_clients_mid"
                                                type='antd-input'
                                                className="mb-0"
                                                label={false}
                                                required={false}
                                            >
                                                <Checkbox
                                                    disabled={isDisabled}
                                                    checked={supplierOrg.targets_clients_mid}>
                                                    <span className="text-sm">
                                                        Mid-Market
                                                    </span>
                                                </Checkbox>
                                            </FormInputComponent>
                                        </div>
                                        <div className="basis-1/2">
                                            <FormInputComponent
                                                value={supplierOrg.targets_clients_small}
                                                fieldName="targets_clients_small"
                                                type='antd-input'
                                                className="mb-0"
                                                label={false}
                                                required={false}
                                            >
                                                <Checkbox
                                                    disabled={isDisabled}
                                                    checked={supplierOrg.targets_clients_small}>
                                                    <span className="text-sm">
                                                        SMB (Small-Medium Business)
                                                    </span>
                                                </Checkbox>
                                            </FormInputComponent>
                                        </div>
                                        <div className="basis-1/2">
                                            <FormInputComponent
                                                value={supplierOrg.targets_clients_startup}
                                                fieldName="targets_clients_startup"
                                                type='antd-input'
                                                className="mb-0"
                                                label={false}
                                                required={false}>
                                                <Checkbox
                                                    disabled={isDisabled}
                                                    checked={supplierOrg.targets_clients_startup}>
                                                    <span className="text-sm">
                                                        Start-Up
                                                    </span>
                                                </Checkbox>
                                            </FormInputComponent>
                                        </div>
                                    </div>

                                    {/*<FormInputComponent*/}
                                    {/*    type="hidden"*/}
                                    {/*    value={supplierOrg?.has_set_target_client_size}*/}
                                    {/*    fieldName="has_set_target_client_size"*/}
                                    {/*    required*/}
                                    {/*/>*/}

                                    {!supplierOrg?.has_set_target_client_size && (
                                        <span className="text-xs text-danger">
                                            Please select at least one target client size
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* <hr />
                        <div className="field-section flex-row">
                            <div className="field px-3.5 basis-6/12">
                                <FormInputComponent
                                    fieldName="target_project_budget"
                                    value={supplierOrg.target_project_budget}
                                    label="Budget Range Starting At?"
                                    type='antd-input'
                                    required={false}
                                >
                                    <InputNumber
                                        disabled={isDisabled}
                                        min={100}
                                        controls={false}
                                        max={1000000}
                                        formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                        placeholder="Enter minimum budget"
                                        style={{ width: '100%' }}
                                    />
                                </FormInputComponent>
                            </div>
                        </div> */}


                        <hr />
                        <div className="">
                            <div className="field-section flex-row">
                                <div className="field">
                                    <div className="form-title-section">
                                        <div className="step-title-content">
                                            <div>
                                                <h3 className="form-title">
                                                    Minimum Size of New Business Opportunities I'm Interest In
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="field-section flex-row">
                                <div className="field px-3.5 basis-6/12">
                                    <FormInputComponent
                                        fieldName="target_project_budget"
                                        value={supplierOrg.target_project_budget}
                                        label="Project Budget (One-Time)"
                                        type='antd-input'
                                        required={true}
                                    >
                                        <InputNumber
                                            disabled={isDisabled}
                                            min={100}
                                            controls={false}
                                            max={1000000}
                                            formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                            placeholder="Enter minimum budget"
                                            style={{ width: '100%' }}
                                        />
                                    </FormInputComponent>
                                </div>
                            </div>
                            <div className="field-section flex-row">
                                <div className="field px-3.5 basis-6/12">
                                    <FormInputComponent
                                        fieldName="target_annual_fees"
                                        value={supplierOrg.target_annual_fees}
                                        label="Annual Client Spend (Ongoing)"
                                        type='antd-input'
                                        required={true}
                                    >
                                        <InputNumber
                                            disabled={isDisabled}
                                            min={100}
                                            controls={false}
                                            max={1000000}
                                            formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                            placeholder="Enter minimum budget"
                                            style={{ width: '100%' }}
                                        />
                                    </FormInputComponent>
                                </div>
                            </div>
                        </div>


                    </div>
                </Form>
            </div>
        </div>
    )
})
export default SupplierInfoStep

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};